import React from 'react';

import styles from './index.module.scss';

export default function Separator({ children = 'or log in with' }: React.PropsWithChildren): React.ReactElement {
  return <div className={styles.separator}>{children}</div>;
}
